/**
 * @generated SignedSource<<84a9db0b8c9eda05241911f47ef005d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierTypeId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierUseCodeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityId",
        "variableName": "facilityId"
      },
      {
        "kind": "Variable",
        "name": "identifierTypeId",
        "variableName": "identifierTypeId"
      },
      {
        "kind": "Variable",
        "name": "identifierUseCode",
        "variableName": "identifierUseCodeId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewFacilityIdentifierModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "FacilityIdentifierModifyPayload",
            "kind": "LinkedField",
            "name": "createIdentifier",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityIdentifier",
                "kind": "LinkedField",
                "name": "facilityIdentifier",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityIdentifier",
                        "kind": "LinkedField",
                        "name": "identifiers",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityIdentifiers_Identifiers"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewFacilityIdentifierModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityMutationGroup",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "FacilityIdentifierModifyPayload",
            "kind": "LinkedField",
            "name": "createIdentifier",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityIdentifier",
                "kind": "LinkedField",
                "name": "facilityIdentifier",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityIdentifier",
                        "kind": "LinkedField",
                        "name": "identifiers",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IdentifierType",
                            "kind": "LinkedField",
                            "name": "identifierType",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IdentifierUseCode",
                            "kind": "LinkedField",
                            "name": "identifierUseCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ae5ea82c56b87be2276901786a04bfb",
    "id": null,
    "metadata": {},
    "name": "NewFacilityIdentifierModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewFacilityIdentifierModalMutation(\n  $facilityId: ID!\n  $identifierTypeId: ID!\n  $identifierUseCodeId: ID!\n  $value: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facility {\n    createIdentifier(input: {facilityId: $facilityId, identifierTypeId: $identifierTypeId, identifierUseCode: $identifierUseCodeId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityIdentifier {\n        id\n        facility {\n          identifiers {\n            ...FacilityIdentifiers_Identifiers\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityIdentifiers_Identifiers on FacilityIdentifier {\n  id\n  identifierType {\n    display\n    id\n  }\n  identifierUseCode {\n    display\n    id\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "8143a1e7773a44b349d5f5617abcf108";

export default node;
